import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import CalendarComponent from './CalendarComponent'
import '../../assests/styles/calendar/calendarMonthView.scss'
import '../../assests/styles/calendar/calendarWeekView.scss'
import '../../assests/styles/calendar/calendarDayView.scss'
import '../../assests/styles/calendar/calendarNav.scss'
import Header from '../header/Header'
import TasksModal from '../management/tasks/TasksModal'
import EventsModal from '../eventos/EventsModal'
import { tasksActions } from '../../actions/tasksActions'
import { phasesActions } from '../../actions/phasesActions'
import { eventsActions } from '../../actions/eventsActions'
import { businessunitsActions } from '../../actions/businessunitsActions'
import { contactsApi } from '../../api/contactsApi'
import { swalAlertError, swalSuccessGeneral } from '../../utils/swalAlert'
import { swalMssgs } from '../../constantes/swalMssgs'
import { onSubmitText } from '../../constantes/onSubmitText'
import { formatDateForInput } from '../../utils/date'
import { eventosActions } from '../../actions/eventosActions'
import { hospitalsActions } from '../../actions/hospitalsActions'
import { specialtiesActions } from '../../actions/specialtiesActions'

const CalendarContainer = () => {
  const history = useHistory()
  const tasks = useSelector((state) => state.tasks)
  const phases = useSelector((state) => state.phases || [])
  const events = useSelector((state) => state.events || [])
  const businessunits = useSelector((state) => state.businessunits || [])
  const hospitals = useSelector((state) => state.hospitals || [])
  const specialties = useSelector((state) => state.specialties || [])
  const userProfile = useSelector((state) => state.userProfile || {})

  const [items, setItems] = useState([])
  const [localContacts, setLocalContacts] = useState([])

  const [newTask, setNewTask] = useState({
    id_Usuario:
      userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : '',
    id_Contacto: '',
    id_TipoFase: '',
    id_TipoAsunto: '',
    asunto: '',
    fecha: '',
    descripcion: '',
    isVerCaledario: true,
    id_Evento: '',
    id_NegocioUnidades: [],
    hospitales: '',
    especialidades: '',
  })
  const [taskModalIsOpen, setTaskModalIsOpen] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [taskToEdit, setTaskToEdit] = useState(null)

  // Estado para el modal de eventos (solo visualización)
  const [eventModalIsOpen, setEventModalIsOpen] = useState(false)
  const [selectedEvento, setSelectedEvento] = useState({
    id_Evento: '',
    nombre: '',
    fechaInicio: '',
    fechaFinal: '',
    descripcion: '',
    ubicacion: '',
    fechaCreacion: '',
    businessUnits: [],
    coste1: '',
    coste2: '',
    info1: '',
    info2: '',
    info3: '',
  })

  const dispatch = useDispatch()
  const getAllTasks = () => dispatch(tasksActions.getAllTasks(0))
  const createTask = (task) => dispatch(tasksActions.newTask(task))
  const updateTask = (task) => dispatch(tasksActions.updateTask(task))
  const getAllPhases = () => dispatch(phasesActions.getAllPhases())
  const getAllTiposAsunto = () => dispatch(eventsActions.getAllEvents())
  const getAllEventos = () => dispatch(eventosActions.getAllEventos())
  const getAllHospitals = () => dispatch(hospitalsActions.getAllHospitals())
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties())

  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())

  const getAllContacts = async () => {
    try {
      const responseContacts = await contactsApi.getAllContacts()
      if (responseContacts && responseContacts.data) {
        setLocalContacts(responseContacts.data)
      }
    } catch (error) {
      console.error('Error loading contacts:', error)
    }
  }

  useEffect(() => {
    loadCalendarItems()
    getAllPhases()
    getAllTiposAsunto()
    getAllBusinessUnits()
    getAllHospitals()
    getAllSpecialties()
    getAllContacts()
  }, [])

  useEffect(() => {
    const handleFocus = () => {
      loadCalendarItems()
    }

    window.addEventListener('focus', handleFocus)
    return () => {
      window.removeEventListener('focus', handleFocus)
    }
  }, [])

  const retrieveTasks = async () => {
    const responseTasks = await getAllTasks()
    try {
      if (
        !responseTasks ||
        !responseTasks.payload ||
        responseTasks.payload.length === 0
      ) {
        return []
      }

      const taskCalendar = responseTasks.payload.filter(
        (task) => task.isVerCaledario === true,
      )

      const calendarItems = taskCalendar.map((task) => ({
        id: `task_${task.id_Crm}`,
        title: `${task.tipoAsunto || 'Sin tipo'}\n${
          task.asunto || 'Sin asunto'
        }\n${task.contacto || 'Sin contacto'}`,
        start: new Date(task.fecha),
        end: new Date(task.fecha),
        resource: task, // Guardar toda la información de la tarea
        type: 'task', // Marcar como tarea
      }))

      return calendarItems
    } catch (err) {
      console.error('CalendarContainer', 'getTaskCalendar', err)
      return []
    }
  }
  function parseDMYToDate(input) {
    const m = input
      .trim()
      .match(
        /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})(?:\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/,
      )
    if (!m) throw new Error(`Fecha no válida: "${input}"`)

    const [, d, mo, y, h = '0', mi = '0', s = '0'] = m
    const date = new Date(
      Number(y),
      Number(mo) - 1, // meses 0-11
      Number(d),
      Number(h),
      Number(mi),
      Number(s),
    )

    if (isNaN(date.getTime())) {
      throw new Error(`Fecha inválida tras parseo: "${input}"`)
    }
    return date // Hora local
  }

  // Función para combinar eventos y tareas
  const loadCalendarItems = async () => {
    try {
      const [tasksData, eventsData] = await Promise.all([
        retrieveTasks(),
        retrieveEventos(),
      ])

      const combinedItems = [...(tasksData || []), ...(eventsData || [])]
      setItems(combinedItems)
    } catch (error) {
      console.error('Error loading calendar items:', error)
      setItems([])
    }
  }

  const retrieveEventos = async () => {
    const responseEvents = await getAllEventos()

    try {
      if (
        !responseEvents ||
        !responseEvents.payload ||
        responseEvents.payload.length === 0
      ) {
        return []
      }

      const eventsCalendar = responseEvents.payload

      console.log("retrieveEventos", eventsCalendar)

      const eventsItems = eventsCalendar.map((event) => {
        // Parsear fecha de inicio y final a objetos Date
        const startDate = new Date(event.fechaInicio)
        const endDate = new Date(event.fechaFinal)
        // Añadir 1 día a la fecha final
        endDate.setDate(endDate.getDate() + 1)

        return {
          id: `event_${event.id_Evento}`,
          title: `${event.nombre || 'Sin tipo'}\n${event.descripcion || 'Sin asunto'}\n${event.usuarioOrganizador || 'Sin contacto'}`,
          start: startDate,
          end: endDate,
          resource: event, // Guardar toda la información del evento
          type: 'event', // Marcar como evento
        }
      })


      return eventsItems
    } catch (err) {
      console.error('CalendarContainer', 'getEventCalendar', err)
      return []
    }
  }

  // Funciones para el modal de tareas
  const openNewTaskModal = (prefilledDate = null) => {
    setNewTask({
      id_Usuario:
        userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : '',
      id_Contacto: '',
      id_TipoFase: '',
      id_TipoAsunto: '',
      asunto: '',
      fecha: prefilledDate || '',
      descripcion: '',
      isVerCaledario: true, // Por defecto true para tareas del calendario
      id_Evento: '',
      id_NegocioUnidades: [],
      hospitales: '',
      especialidades: '',
    })
    setIsEditMode(false)
    setTaskToEdit(null)
    setTaskModalIsOpen(true)
  }

  const openEditTaskModal = (task) => {
    setNewTask({
      id_Crm: task.id_Crm || '',
      id_Usuario: task.id_Usuario || '',
      id_Contacto: task.id_Contacto || '',
      id_TipoFase: task.id_TipoFase || '',
      id_TipoAsunto: task.id_TipoAsunto || '',
      id_Evento: task.id_Evento || '',
      asunto: task.asunto || '',
      fecha: formatDateForInput(task.fecha || ''),
      descripcion: task.descripcion || '',
      isVerCaledario: task.isVerCaledario || false,
      id_NegocioUnidades: task.id_NegocioUnidades || [],
      hospitales: task.hospitales || '',
      especialidades: task.especialidades || '',
    })
    setIsEditMode(true)
    setTaskToEdit(task)
    setTaskModalIsOpen(true)
  }

  const closeTaskModal = () => {
    setTaskModalIsOpen(false)
    setIsEditMode(false)
    setTaskToEdit(null)
    setNewTask({
      id_Usuario:
        userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : '',
      id_Contacto: '',
      id_TipoFase: '',
      id_TipoAsunto: '',
      asunto: '',
      fecha: '',
      descripcion: '',
      isVerCaledario: true,
      id_Evento: '',
      id_NegocioUnidades: [],
      hospitales: '',
      especialidades: '',
    })
  }

  // Funciones para el modal de eventos (solo visualización)
  const openViewEventModal = (eventoData) => {
    // Transformar id_NegocioUnidades a businessUnits para el frontend si existen
    const businessUnits =
      eventoData.id_NegocioUnidades && businessunits
        ? businessunits.filter((bu) =>
            eventoData.id_NegocioUnidades.includes(bu.id_NegocioUnidad),
          )
        : []

    setSelectedEvento({
      id_Evento: eventoData.id_Evento || '',
      nombre: eventoData.nombre || '',
      fechaInicio: formatDateForInput(eventoData.fechaInicio || ''),
      fechaFinal: formatDateForInput(eventoData.fechaFinal || ''),
      descripcion: eventoData.descripcion || '',
      ubicacion: eventoData.ubicacion || '',
      fechaCreacion: eventoData.fechaCreacion || '',
      businessUnits: businessUnits,
      coste1: eventoData.coste1 || '',
      coste2: eventoData.coste2 || '',
      info1: eventoData.info1 || '',
      info2: eventoData.info2 || '',
      info3: eventoData.info3 || '',
    })
    setEventModalIsOpen(true)
  }

  const closeEventModal = () => {
    setEventModalIsOpen(false)
    setSelectedEvento({
      id_Evento: '',
      nombre: '',
      fechaInicio: '',
      fechaFinal: '',
      descripcion: '',
      ubicacion: '',
      fechaCreacion: '',
      businessUnits: [],
      coste1: '',
      coste2: '',
      info1: '',
      info2: '',
      info3: '',
    })
  }

const handleChangeNewTask = (eventOrArray) => {
    // Si recibimos un array de eventos, actualizamos todos los campos
    if (Array.isArray(eventOrArray)) {
      let updatedTask = { ...newTask }
      eventOrArray.forEach((event) => {
        const value =
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
        const name = event.target.name

        // No permitir cambios en las unidades de negocio ya que son solo de lectura
        if (name === 'id_NegocioUnidades') {
          return
        }

        updatedTask = { ...updatedTask, [name]: value }
      })
      setNewTask(updatedTask)
      return
    }

    // Caso normal: un solo evento
    const value =
      eventOrArray.target.type === 'checkbox'
        ? eventOrArray.target.checked
        : eventOrArray.target.value
    const name = eventOrArray.target.name

    if (name === 'id_NegocioUnidades') {
      return
    }

    setNewTask({ ...newTask, [name]: value })
  }

  const handleSubmitNewTask = async (event) => {
    event.preventDefault()
    try {
      // Asegurar que siempre tenga un usuario asignado
      const currentUserId =
        userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : ''

      const dataToSend = {
        ...newTask,
        id_Usuario: newTask.id_Usuario || currentUserId, // Usar el usuario actual si no está definido
      }

      if (isEditMode) {
        const response = await updateTask(dataToSend)
        if (response && response.type && response.type.includes('SUCCESS')) {
          swalSuccessGeneral(
            'Actualizado Correctamente',
            swalMssgs.UPDATE_SUCCES,
          )
          closeTaskModal()
          loadCalendarItems() // Recargar calendario combinado
        } else {
          swalAlertError('Error al actualizar el lead')
        }
      } else {
        const response = await createTask(dataToSend)
        if (response && response.type && response.type.includes('SUCCESS')) {
          swalSuccessGeneral('Creado Correctamente', swalMssgs.NEW_SUCCES)
          closeTaskModal()
          loadCalendarItems() // Recargar calendario combinado
        } else {
          swalAlertError('Error al crear el lead')
        }
      }
    } catch (error) {
      console.error('Error with task:', error)
      const errorMessage =
        error.response && error.response.data
          ? error.response.data
          : isEditMode
          ? 'Error al actualizar el lead'
          : 'Error al crear el lead'
      swalAlertError(errorMessage)
    }
  }

  const validateFormNewTask = () => {
    const hasBusinessUnits =
      newTask.id_NegocioUnidades && newTask.id_NegocioUnidades.length > 0
    const hasEventRelated =
      newTask.id_Evento && newTask.id_Evento.toString().trim() !== ''

    return (
      newTask.id_TipoAsunto &&
        newTask.id_TipoAsunto.toString().trim() !== '' &&
        newTask.asunto &&
        newTask.asunto.trim() !== '' &&
        newTask.id_TipoFase &&
        newTask.id_TipoFase.toString().trim() !== '' &&
        newTask.id_Contacto &&
        newTask.id_Contacto.toString().trim() !== '' &&
        newTask.fecha &&
        newTask.fecha.trim() !== '' &&
        newTask.descripcion &&
        newTask.descripcion.trim() !== '' &&
        (hasBusinessUnits || hasEventRelated), // Permitir crear si hay unidades de negocio O evento relacionado
      newTask.hospitales &&
        newTask.hospitales.trim() !== '' &&
        newTask.especialidades &&
        newTask.especialidades.trim() !== ''
    )
  }

  const handleSelectEvent = (event) => {
    if (event.resource && event.type) {
      if (event.type === 'task') {
        // Abrir modal de tarea para editar
        openEditTaskModal(event.resource)
      } else if (event.type === 'event') {
        // Abrir modal de evento en modo view
        openViewEventModal(event.resource)
      }
    }
  }

  // Función para manejar la selección de un slot de tiempo (crear nueva tarea)
  const handleSelectSlot = ({ start }) => {
    // Formatear la fecha para el formulario (YYYY-MM-DD) manteniendo la zona horaria local
    const date = new Date(start)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const formattedDate = `${year}-${month}-${day}`

    // Abrir modal de nueva tarea con la fecha preseleccionada
    openNewTaskModal(formattedDate)
  }
  return (
    <>
      <div className='products'>
        <Header text={'Agenda'} route={() => history.goBack()} backBtn={true} />
        {/* <div className='calendar-container'> */}
        <CalendarComponent
          myEventsList={items}
          onSelectEvent={handleSelectEvent}
          onSelectSlot={handleSelectSlot}
        />
        {/* </div> */}
      </div>

      {/* Modal para crear y editar tareas */}
      <TasksModal
        modalIsOpen={taskModalIsOpen}
        closeModal={closeTaskModal}
        inputs={newTask}
        handleChange={handleChangeNewTask}
        handleSubmit={handleSubmitNewTask}
        validateForm={validateFormNewTask}
        textBtn={isEditMode ? onSubmitText.Guardar : onSubmitText.Crear}
        phases={phases}
        contacts={localContacts}
        events={events}
        businessunits={businessunits}
        hospitals={hospitals}
        specialties={specialties}
        isEdit={isEditMode}
      />

      <EventsModal
        modalIsOpen={eventModalIsOpen}
        closeModal={closeEventModal}
        inputs={selectedEvento}
        handleChange={() => {}} // No se necesita cambio en modo view
        handleSubmit={() => {}} // No se necesita submit en modo view
        validateForm={true} // Siempre válido en modo view
        textBtn=''
        businessunits={businessunits}
        isEdit={false}
        isViewMode={true} // Siempre en modo view
      />
    </>
  )
}
export default CalendarContainer
